import styled from 'styled-components';
import { STATIC_IMAGE_URLS } from 'modules/core/constants';
import { WindowBreakpoints } from 'modules/core/enums/windowBreakpoints.enum';
import { COLORS } from 'modules/core/theme/colors';

export const ErrorWrapper = styled.div`
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  min-height: calc(100vh - 42px);
  background: url(${STATIC_IMAGE_URLS.errorBackground.bigger}) no-repeat center;
  background-size: cover;

  @media (max-width: ${WindowBreakpoints.xxxLarge}px) {
    background: url(${STATIC_IMAGE_URLS.errorBackground.smaller}) no-repeat center;
    background-size: cover;
  }
`;

export const ErrorCard = styled.div`
  width: 100%;
  padding: 15px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
  font-size: 15px;
  box-sizing: border-box;
`;

export const ErrorHeader = styled.div`
  padding: 0 10px 10px 10px;
  color: #4e6280;
  border-bottom: 1px solid #e4e4e4;
  font-family: 'Roboto', sans-serif;

  h1 {
    margin: 0;
    font-weight: 600;
  }
`;

export const ErrorBody = styled.div`
  padding: 10px 10px 0 10px;

  p {
    color: #4f4f50;
    font-size: 18px;
    margin-bottom: 3px;
    margin-top: 0;
    font-family: 'Roboto', sans-serif;
  }
`;

export const ErrorLinks = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding-left: 10px;
  font-family: 'Roboto', sans-serif;

  a {
    position: relative;
    cursor: pointer;
    font-size: 18px;
    padding-left: 4px;
    color: ${({ theme: { colors } }) => colors['blue-4']};
    line-height: 1;

    &:hover {
      color: #23527c;
    }

    &:not(:last-child) {
      margin-right: 20px;
    }
  }
`;

export const SSOErrorWrapper = styled(ErrorWrapper)`
  display: flex;
  justify-content: center;
  padding: 120px 370px;
  height: calc(100vh - 42px);
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  line-height: 1;

  @media (max-width: ${WindowBreakpoints.xxxxLarge}px) {
    padding: 120px 280px;
  }

  @media (max-width: ${WindowBreakpoints.xxxLarge}px) {
    padding: 120px 180px;
  }

  @media (max-width: ${WindowBreakpoints.xxLarge}px) {
    padding: 75px 110px;
  }
`;

export const SSOErrorHeader = styled.h1`
  font-size: 35px;
  font-weight: 500;
`;

export const SSOErrorSubheader = styled.p`
  font-size: 13px;
  margin-bottom: 30px;

  @media (max-width: ${WindowBreakpoints.xxLarge}px) {
    margin-right: 150px;
  }
`;

export const SSOErrorDescription = styled.p`
  font-size: 17px;
  font-weight: 500;
  margin-bottom: 28px;

  @media (max-width: ${WindowBreakpoints.xxLarge}px) {
    margin-right: 150px;
  }
`;

export const SSOStep = styled.div`
  font-size: 15px;
  padding: 2px 5px;
  background-color: #1a365d;
  color: white;
  border-radius: 4px;
  display: inline-block;
  white-space: nowrap;
  margin-bottom: 0;
`;

export const SSOStepText = styled.p`
  font-size: 17px;
  margin: 0;
`;

export const HighlightedText = styled.span`
  color: ${COLORS.BLUE_11};
  display: inline;
  white-space: inherit;
`;

export const SSOErrorContentRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  @media (max-width: ${WindowBreakpoints.xxxLarge}px) {
    gap: 0;
  }
`;

export const SSOContactSupport = styled.div`
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  font-size: 13px;
  padding: 0 160px;
  box-sizing: border-box;

  @media (max-width: ${WindowBreakpoints.xxxLarge}px) {
    font-size: 13px;
    padding: 0 110px;
    bottom: 55px;
  }
`;

export const SSOErrorImage = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: ;
  width: 455px;
  height: 370px;
  background-image: url(${STATIC_IMAGE_URLS.ssoErrorModalRouteOne});
  background-size: contain;
  background-repeat: no-repeat;
  margin-top: -7px;

  @media (max-width: ${WindowBreakpoints.xxLarge}px) {
    width: 375px;
    height: 290px;
  }
`;

export const SSOStepRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 5px;
  margin-bottom: 18px;
  margin-left: 30px;
`;

export const SSOErrorProviderLogo = styled.img`
  display: block;
  width: 100%;
  max-width: 210px;
  height: auto;
  margin: 0 0 22px;

  @media (max-width: ${WindowBreakpoints.xxLarge}px) {
    max-width: 170px;
    margin-bottom: 16px;
  }
`;

export const SSOErrorActionsHeading = styled.p`
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 12px;
`;

export const SSOErrorActionsList = styled.ul`
  margin: 0;
  padding-left: 20px;

  li {
    font-size: 17px;
    line-height: 1.4;

    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
`;

export const MaintenanceContent = styled.div`
  ${SSOErrorHeader} {
    font-size: 44px;
    margin-bottom: 0.5em;
    font-weight: 800;
  }

  ${SSOErrorDescription} {
    font-size: 22px;
    line-height: 1.3;
    margin-bottom: 2em;
    font-weight: 500;
  }

  ${SSOErrorActionsHeading} {
    font-size: 19px;
    font-weight: 400;
    margin-bottom: 10px;
  }

  ${SSOErrorActionsList} li {
    font-size: 21px;
  }

  ${SSOContactSupport} {
    font-size: 16px;
  }
`;
